'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _lodash = require('lodash.find');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.groupby');

var _lodash4 = _interopRequireDefault(_lodash3);

var _audiences = require('redux/modules/audiences');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudienceBox = (_dec = (0, _reactRedux.connect)(function (state) {
  return { audiences: state.audiences.audiences };
}, { loadAudiences: _audiences.load, isAudienceLoaded: _audiences.isLoaded }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AudienceBox, _Component);

  function AudienceBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AudienceBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AudienceBox.__proto__ || (0, _getPrototypeOf2.default)(AudienceBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popoverOpen: false,
      selectedAudiences: _this.props.selectedAudiences
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AudienceBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var loadAudiences = this.props.loadAudiences; // eslint-disable-line no-shadow

      if (!(0, _audiences.isLoaded)(this.context.store.getState())) {
        loadAudiences({ per: 100 });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedAudiences !== this.props.selectedAudiences) {
        this.setState({ selectedAudiences: nextProps.selectedAudiences });
      }
    }
  }, {
    key: 'getCheckboxes',
    value: function getCheckboxes() {
      return this.refs.checkboxesGroup.querySelectorAll('input[type="checkbox"]');
    }
  }, {
    key: 'getCheckedValues',
    value: function getCheckedValues() {
      var checkboxes = this.getCheckboxes();

      var checked = [];
      for (var idx = 0, length = checkboxes.length; idx < length; idx++) {
        if (checkboxes[idx].checked) {
          checked.push(parseInt(checkboxes[idx].value, 10));
        }
      }

      return checked;
    }
  }, {
    key: 'getChecked',
    value: function getChecked() {
      var checkboxes = this.getCheckboxes();

      var checked = [];
      for (var idx = 0, length = checkboxes.length; idx < length; idx++) {
        if (checkboxes[idx].checked) {
          var audience = this.filterAudienceById(parseInt(checkboxes[idx].value, 10));
          if (audience) {
            checked.push(audience);
          }
        }
      }

      return checked;
    }
  }, {
    key: 'filterAudienceById',
    value: function filterAudienceById(id) {
      var audiences = this.props.audiences;


      return (0, _lodash2.default)(audiences.data, { id: id });
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.refs.audienceBoxPopover.hide();
    }
  }, {
    key: 'handleOK',
    value: function handleOK() {
      var _this2 = this;

      var onChange = this.props.onChange;


      this.refs.audienceBoxPopover.hide();

      this.setState({
        selectedAudiences: this.getChecked()
      }, function () {
        onChange(_this2.state.selectedAudiences);
      });
    }
  }, {
    key: 'handleOnChange',
    value: function handleOnChange() {
      this.setState({
        selectedAudiences: this.getChecked()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          popoverContainer = _props.popoverContainer,
          polyglot = _props.polyglot;
      var _props2 = this.props,
          audiences = _props2.audiences,
          availableAudiences = _props2.availableAudiences;
      var selectedAudiences = this.state.selectedAudiences;


      var boxUI = '';
      if (selectedAudiences.length <= 0) {
        // Empty
        boxUI = _react2.default.createElement(AudienceBox.Empty, { polyglot: polyglot });
      } else {
        // HasAudience
        boxUI = _react2.default.createElement(AudienceBox.HasAudience, { polyglot: polyglot, selectedAudiences: selectedAudiences });
      }
      var audiencesWithParent = audiences.data.filter(function (audience) {
        return audience.parent_id !== null;
      });
      var audiencesToGroup = availableAudiences && audiences.data.length ? availableAudiences : audiencesWithParent;
      var audienceGroups = (0, _lodash4.default)(audiencesToGroup, function (audience) {
        return audience.parent_id;
      });

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'audienceBoxPopover',
          trigger: 'click',
          placement: 'top',
          rootClose: true,
          container: popoverContainer,
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'audienceBoxPopover', className: 'audience-box-popover ' + ((0, _keys2.default)(audienceGroups).length > 2 ? 'wide' : 'narrow') },
            _react2.default.createElement(
              'div',
              { className: 'audienceGroups', ref: 'checkboxesGroup' },
              (0, _keys2.default)(audienceGroups).map(function (key) {
                var audienceGroup = audienceGroups[key];
                var parentName = audiences.data.filter(function (audience) {
                  return audience.id === Number(key);
                })[0].name;
                return _react2.default.createElement(AudienceBox.AudienceGroup, { key: 'group-' + key, name: parentName, audiences: audienceGroup, selectedAudiences: selectedAudiences });
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'popover-actions' },
                  _react2.default.createElement(
                    'div',
                    { className: 'buttons' },
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'btn btn-default btn-outline',
                        onClick: this.handleCancel.bind(this)
                      },
                      polyglot.t('button.cancel')
                    ),
                    '\xA0',
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'btn btn-primary',
                        onClick: this.handleOK.bind(this)
                      },
                      'OK'
                    )
                  )
                )
              )
            )
          )
        },
        boxUI
      );
    }
  }], [{
    key: 'AudienceGroup',
    value: function AudienceGroup(_ref2) {
      var name = _ref2.name,
          audiences = _ref2.audiences,
          selectedAudiences = _ref2.selectedAudiences;

      return _react2.default.createElement(
        'div',
        { className: 'audienceGroup' },
        _react2.default.createElement(
          'h4',
          null,
          name
        ),
        _react2.default.createElement(
          'ul',
          { className: 'audiences' },
          audiences.map(function (audience) {
            return _react2.default.createElement(AudienceBox.AudienceItem, { key: 'audience-' + audience.id, audience: audience, selectedAudiences: selectedAudiences });
          })
        )
      );
    }
  }, {
    key: 'AudienceItem',
    value: function AudienceItem(_ref3) {
      var audience = _ref3.audience,
          selectedAudiences = _ref3.selectedAudiences;

      var isChecked = selectedAudiences.map(function (aud) {
        return aud.id;
      }).indexOf(audience.id) >= 0;
      return _react2.default.createElement(
        'li',
        { key: 'audience-' + audience.id },
        _react2.default.createElement(_components.Input, {
          name: 'audiences',
          id: 'audience-' + audience.id,
          type: 'checkbox',
          defaultChecked: isChecked,
          label: audience.name,
          value: audience.id
        })
      );
    }
  }, {
    key: 'Empty',
    value: function Empty(_ref4) {
      var onClick = _ref4.onClick,
          polyglot = _ref4.polyglot;

      return _react2.default.createElement(
        'div',
        { className: 'dashed-box audience-box empty', onClick: onClick },
        _react2.default.createElement('span', { className: 'icon-cg-buddies left-icon' }),
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('events.audiencebox.name')
        )
      );
    }
  }, {
    key: 'HasAudience',
    value: function HasAudience(_ref5) {
      var selectedAudiences = _ref5.selectedAudiences,
          onClick = _ref5.onClick,
          polyglot = _ref5.polyglot;

      return _react2.default.createElement(
        'div',
        { className: 'line-box event-content-box audience-box has-audience', onClick: onClick },
        _react2.default.createElement(
          'h3',
          { className: 'box-header' },
          polyglot.t('events.audiencebox.name')
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-content' },
          selectedAudiences.map(function (audience) {
            return _react2.default.createElement(
              'div',
              { key: 'audience-' + audience.id, className: 'text-left' },
              audience.name
            );
          })
        )
      );
    }
  }]);
  return AudienceBox;
}(_react.Component), _class2.propTypes = {
  polyglot: _propTypes2.default.object.isRequired,
  availableAudiences: _propTypes2.default.array,
  popoverContainer: _propTypes2.default.any,
  onChange: _propTypes2.default.func,
  selectedAudiences: _propTypes2.default.array,
  audiences: _propTypes2.default.object,
  loadAudiences: _propTypes2.default.func
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = AudienceBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/AudienceBox.js
// module id = 2198
// module chunks = 0